import React from "react";

/**
 * chip strip of followed municipalities.
 */
const MunicipalityChipStrip = ({
  municipalities,
  homeId,
  activeId,
  onSelect,
  translate,
}) => {
  if (!municipalities || municipalities.length === 0) {
    return (
      <div className="muni-chip-strip muni-chip-strip--empty">
        {translate ? translate("no_followed_municipalities") : "Geen gevolgde gemeenten"}
      </div>
    );
  }

  const activeMunicipality = municipalities.find((m) => m.id === activeId);

  return (
    <div className="muni-chip-strip">
      <div className="muni-chip-strip__chips">
        {municipalities.map((muni) => {
          const isHome = muni.is_home || muni.id === homeId;
          const isActive = muni.id === activeId;
          const hasPubs = muni.has_publications !== false;
          return (
            <button
              type="button"
              key={muni.id}
              className={
                "muni-chip" +
                (isActive ? " muni-chip--active" : "") +
                (isHome ? " muni-chip--home" : "") +
                (!hasPubs ? " muni-chip--no-pubs" : "")
              }
              onClick={() => onSelect && onSelect(muni.id)}
              title={
                hasPubs
                  ? muni.name
                  : `${muni.name} — ${
                      translate
                        ? translate("no_publications_yet")
                        : "Nog geen publicaties beschikbaar"
                    }`
              }
            >
              <span className="muni-chip__name">{muni.name}</span>
              {isHome && (
                <span className="muni-chip__badge">
                  {translate ? translate("woon_badge") || "WOON" : "WOON"}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {activeMunicipality && (
        <div className="muni-chip-strip__active-info">
          <div className="active-info__label">
            {translate ? translate("active_selection") || "Actieve selectie" : "Actieve selectie"}
          </div>
          <div className="active-info__name">{activeMunicipality.name}</div>
          <div className="active-info__type">
            {(activeMunicipality.is_home || activeMunicipality.id === homeId)
              ? translate
                ? translate("residential_municipality") || "Type: woongemeente"
                : "Type: woongemeente"
              : translate
              ? translate("followed_municipality") || "Type: gevolgde gemeente"
              : "Type: gevolgde gemeente"}
          </div>
          <div className="active-info__hint">
            {translate
              ? translate("click_chip_to_switch") || "Klik op een andere chip om te wisselen."
              : "Klik op een andere chip om te wisselen."}
          </div>
        </div>
      )}
    </div>
  );
};

export default MunicipalityChipStrip;
